import React, { FC } from 'react';

// --- Utility ---
const cn = (...classes: (string | undefined | null | false)[]) => {
    return classes.filter(Boolean).join(' ');
};

interface LoadingProps {
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    size?: 'sm' | 'md' | 'lg';
    centered?: boolean; // If true, wraps in a flex container
    text?: string;
    className?: string;
}

export const LoadingSpinner: FC<LoadingProps> = ({
    variant = 'primary',
    size = 'md',
    centered = false,
    text,
    className
}) => {

    // Determine size class
    const sizeClass = size === 'sm' ? 'spinner-border-sm' : (size === 'lg' ? 'w-50px h-50px' : '');

    const spinner = (
        <div className="d-flex align-items-center gap-2">
            <div
                className={cn(`spinner-border text-${variant}`, sizeClass, className)}
                role="status"
            >
                <span className="visually-hidden">Loading...</span>
            </div>
            {text && <span className="text-muted fw-bold fs-6">{text}</span>}
        </div>
    );

    // If centered, wrap in the flex utility you were using
    if (centered) {
        return (
            <div className="d-flex justify-content-center align-items-center py-10 w-100">
                {spinner}
            </div>
        );
    }

    return spinner;
};